import { FOUNDER, BRAND } from "@/config/site";
import { cn } from "@/lib/utils";

// Founder card — displays the approved portrait of Donald Lee, Sr.
// Image is first in the DOM so it stacks ABOVE the bio on mobile and sits
// BESIDE it on desktop. The photo is used as-is (no retouching/alteration).
export const FounderCard = ({ className = "" }) => (
  <div
    className={cn(
      "grid gap-8 md:grid-cols-5 md:gap-12 md:items-start",
      className
    )}
    data-testid="founder-card"
  >
    <div className="md:col-span-2">
      <div className="relative aspect-[4/5] overflow-hidden rounded-3xl border border-legacy-gold/30 bg-[#0f1a18]">
        <img
          src={FOUNDER.photo}
          alt={FOUNDER.photoAlt}
          loading="lazy"
          width="900"
          height="1125"
          className="h-full w-full object-cover object-top"
          data-testid="founder-photo"
        />
      </div>
    </div>

    <div className="md:col-span-3">
      <span className="inline-flex items-center gap-2 rounded-full border border-legacy-gold/40 bg-legacy-gold/10 px-4 py-1.5 text-xs font-medium uppercase tracking-wider text-legacy-gold">
        Black-Owned &amp; Veteran-Owned
      </span>
      <h3 className="mt-5 font-heading text-3xl md:text-4xl text-white">
        {FOUNDER.name}
      </h3>
      <p className="mt-2 text-legacy-mint font-medium">{FOUNDER.title}</p>
      <p className="mt-6 text-white/70 leading-relaxed max-w-xl">
        {BRAND.name} was founded on a commitment to professional,
        client-centered massage therapy and wellness in Greater Houston. As part
        of Legacy Forge Collective, Legacy Spa is rooted in service, care, and a
        lasting standard of quality.
      </p>
    </div>
  </div>
);
